export default __webpack_public_path__ + "static/media/img7.78150d58.png";